export default __webpack_public_path__ + "static/media/lhype-logo.95592125.svg";